import { gql } from '@apollo/client';

export const CampaignCallCenterQuery = gql`
  query CampaignCallCenter($campaignId: ID!) {
    campaign(id: $campaignId) {
      id
      companyId
      callCenterConfiguration {
        callCenter {
          id
        }
        didInbound
        didOutbound
        didScheduledOutbound
      }
      brand {
        company {
          id
          callCenters {
            id
            alwaysOpen
            timezone
            holidays
            hours {
              mon {
                from
                to
              }
              tue {
                from
                to
              }
              wed {
                from
                to
              }
              thu {
                from
                to
              }
              fri {
                from
                to
              }
              sat {
                from
                to
              }
              sun {
                from
                to
              }
            }
          }
        }
      }
    }
  }
`;
